<svg class="svg_icon--info" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--info .icon{fill:currentColor;}</style>
  </defs>
  <title>Information</title>
  <g>
    <path class="icon"
          d="M50,4.49A45.86,45.86,0,1,0,95.86,50.35,45.91,45.91,0,0,0,50,4.49Zm0,83.93A38.07,38.07,0,1,1,88.07,50.35,38.12,38.12,0,0,1,50,88.42Z"/>
    <path class="icon"
          d="M43.06,29.5A6.59,6.59,0,0,1,50,22.62a6.59,6.59,0,0,1,6.94,6.88v.19a6.66,6.66,0,0,1-6.94,7,6.66,6.66,0,0,1-6.94-7Zm.73,20a6.21,6.21,0,0,1,12.42,0V73.89a6.21,6.21,0,0,1-12.42,0Z"/>
  </g>
</svg>